import { QuoteDto } from 'src/dtos';
import { Quote } from 'src/models';

export const mapQuoteDtoToModel = (dto: QuoteDto): Quote => ({
  id: dto.Symbol,
  last: dto.LastTradePrice,
  change: dto.NetChange,
  description: dto.Description ?? dto.Symbol,
  symbol: dto.Symbol,
});

export const mapQuoteDtoListToModel = (dtosList: QuoteDto[]): Quote[] => dtosList.map(mapQuoteDtoToModel);
